import { forwardRef } from 'react';

export const MarketIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 110" ref={ref} {...props}>
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M5.5 99.7h100m-8.2-83.2H18.2v54h79.1v-54zM57.8 72v18.6m7-18.6l10 18.6M50.8 72l-10 18.6"
        />
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M32.7 30.5l-4.6-4.7v36.8h63.1l-5.5-5.5M38.2 46.7v9.6m10-19.6v19.6m10-9.6v9.6m10-29.6v29.6m10-9.6v9.6"
        />
      </svg>
    );
  },
);
